import * as React from "react";
import { CommentButtonWrapper } from "./styles";
import Icon from "react-icons-kit";
import { check } from 'react-icons-kit/fa/check'
import { close } from 'react-icons-kit/fa/close'

interface IProps {
    comments: string,
    onSubmit: (comments: string) => void,
    onCancel: () => void
}

interface IState {
    comments: string
}

class DisputeComments extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            comments: props.comments
        };
    }

    handleCommentChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
        this.setState({
            comments: e.currentTarget.value
        });
    }

    handleSubmit = () => {
        this.props.onSubmit(this.state.comments);
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        return (
            <div style={{ flexBasis: '85%' }}>
                <textarea className="form-control" style={{ height: 120, resize: 'none' }} onChange={this.handleCommentChange}>{this.state.comments}</textarea>
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 3 }}>
                    <CommentButtonWrapper bsSize="xs" style={{ fontSize: 14, marginRight: 3 }} onClick={this.handleSubmit}><Icon icon={check} /></CommentButtonWrapper>
                    <CommentButtonWrapper bsSize="xs" style={{ fontSize: 14 }}><Icon icon={close} onClick={this.handleCancel} /></CommentButtonWrapper>
                </div>
            </div>
        )
    }
}

export default DisputeComments;